/**
	* Turn sections into tabs (Elementor)
	* Adds data attributes to section and `autotab` to container
	* Contianer will scope the tabs so we can have multiple per page
	* CSS to be added manually but 
	*
	* Markup:
	* .autotab
	* 	.autotab-buttons <- Added via js bellow
	* 		.autotab-button[data-autotab-section-target="one"]	 <- Added via js bellow
	* 		.autotab-button[data-autotab-section-target="two"]	 <- Added via js bellow
	* 		.autotab-button[data-autotab-section-target="two"]	 <- Added via js bellow
	* 		...
	* 	[data-autotab-section="one"]
	* 	[data-autotab-section="two"]
	* 	[data-autotab-section="three"]
	* 	...
	*/


// Get container for each tab component
const autotabs = document.querySelectorAll('.autotab')

autotabs.forEach((autotab) => {

	// Get all Sections
	const sections = autotab.querySelectorAll('[data-autotab-section]')

	// Make tabs
	const tabs = []

	sections.forEach((section) => {

		// Tab Names (e.g 'Localsearch.com.au' or 'SEO')
		const tab = section.dataset.autotabSection

		tabs.push(tab)
	})

	// Add tabs to DOM
	let tabsContainer = document.createElement('div')

	tabsContainer.classList.add('autotab-buttons')

	tabs.forEach((tab) => {
		tabsContainer.innerHTML += `<span data-autotab-section-target="${tab}" class="autotab-button"> ${tab}</span> `
	})

	autotab.insertBefore(tabsContainer, autotab.firstChild)

	const buttons = autotab.querySelectorAll('.autotab-button')

	// Mark active button
	sections.forEach(section => {
		if (section.classList.contains('autotab-section-active')) {
			autotab.querySelector(`[data-autotab-section-target="${section.dataset.autotabSection}"]`)?.classList.add('autotab-button-active')
		}
	})

	buttons.forEach((button) => {

		button.addEventListener('click', (e) => {
			
			// Get this section target
			let section = autotab.querySelector(
				`[data-autotab-section="${e.target.dataset.autotabSectionTarget}"]`
			)

			// reset all buttons
			buttons.forEach(button => button.classList.remove('autotab-button-active'))

			// reset all sections
			sections.forEach(section => section.classList.remove('autotab-section-active'))

			// activate this button
			button.classList.add('autotab-button-active')

			// activate this section
			section.classList.add('autotab-section-active')
		})
	})
})

